import React from 'react';
import styles from './Numbers.module.scss';

const Numbers = ({ stats, dividers = true, additionalClass }) => ( 
  <section className={ styles.Numbers }>
    <div className={ `${ styles.NumbersContent } ${ styles[additionalClass] }` } >
      {
        stats && stats.map(({ number, caption }, key) => (
          <React.Fragment key={ key }>
            { key !== 0 && dividers && <div className={ styles.divider }></div> }
            <div className={ styles.numberAndCaption }>
              <span className={ styles.number }>{ number }</span>
              <span className={ styles.caption }>{ caption }</span>            
            </div>
          </React.Fragment>
        ))
      }
    </div>
  </section>
);
 
export default Numbers;
